export class SolacePropertie {
  serviceToken: string;
  serviceTopic: string;
  subscriptionTopic: string;
  correlationKey: any;

  constructor(
    serviceTopic: string,
    subscriptionTopic: string,
    hashToken: string = 'token',
  ) {
    this.serviceToken = hashToken;
    this.serviceTopic = serviceTopic;
    this.subscriptionTopic = subscriptionTopic;
    this.correlationKey = {
      Symbol: '*',
    };
  }
}
